import { formatCEP } from './formatters'

// Campos do endereço do local do gerador (mesmos nomes do cadastro do cliente).
export const EMPTY_LOCATION = { logradouro: '', number: '', complement: '', district: '', city: '', state: '', zipCode: '', cityCode: '' }

// "Rua X, 10 - Compl. - Bairro - Cidade/UF - CEP 00000-000" a partir de qualquer objeto com esses campos.
export function formatLocation(addr) {
    if (!addr) return ''
    const street = [addr.logradouro, addr.number].filter(Boolean).join(', ')
    const cityState = [addr.city, addr.state].filter(Boolean).join('/')
    const cep = addr.zipCode ? `CEP ${formatCEP(addr.zipCode)}` : ''
    return [street, addr.complement, addr.district, cityState, cep].filter(Boolean).join(' - ')
}

// Texto curto do vínculo, pra lista de geradores do cliente.
export function describeLocation(location) {
    return location && location.sameAsClient === false
        ? formatLocation(location)
        : 'Mesmo endereço do cliente'
}

const ADDRESS_FIELDS = ['logradouro', 'number', 'complement', 'district', 'city', 'state', 'zipCode']

// Endereço de execução do serviço, igual ao que o backend congela na OS ao criá-la
// (helpers/generatorLocation.js): o do gerador se for próprio, senão o do cliente.
export function resolveServiceAddress(client, generator) {
    const location = generator && generator.location
    const source = location && location.sameAsClient === false ? location : (client || {})
    const address = { sameAsClient: !(location && location.sameAsClient === false) }
    ADDRESS_FIELDS.forEach((field) => { address[field] = source[field] ?? '' })
    return address
}

// Endereço da OS já criada. OS antigas (sem serviceAddress) usam o endereço do cliente, como sempre.
export function getOrderServiceAddress(order) {
    return (order && order.serviceAddress) || resolveServiceAddress(order && order.client, null)
}
